import {LOCAL_STORAGE_CSRF_TOKEN, LOCAL_STORAGE_SURL_KEY} from "../constants/session";

export const loadState = () => {
  try {
    const serializedState = localStorage.getItem('state');
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
}

export const saveState = (name, val) => {
  try {
    // const serializedState = JSON.stringify(state);
    sessionStorage.setItem(name, val);
  } catch (err) {
    // ignore errors- should be logged.
    console.log('error on saveState: ', err);
  }
}
